import type { ReactNode } from "react";
import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import { useDeviceType } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@overrides/types";
import { Dialog, DialogContent, Icon } from "@tenant/ui";
import defaultStyles from "./LodgingCancellationPolicyPopup.module.scss";

export interface LodgingCancellationPolicyPopupProps
  extends PlatformComponentProps {
  children?: ReactNode;
  openLodgingCancellationPolicyPopup: boolean;
  onClose: () => void;
}

export const LodgingCancellationPolicyPopup = (
  props: LodgingCancellationPolicyPopupProps
) => {
  const [block, cn] = useModuleBEM(
    useHotelsStyles(
      CoreHotelsComponent.LodgingCancellationPolicyPopup,
      defaultStyles
    ),
    CoreHotelsComponent.LodgingCancellationPolicyPopup
  );

  const { isDesktopAndUp } = useDeviceType();

  const { t } = useI18nContext();
  return (
    <div className={block}>
      <Dialog
        open={props.openLodgingCancellationPolicyPopup}
        onClose={props.onClose}
      >
        <DialogContent
          title={
            <div>{t("core-hotels.lodgingCancellationPolicyModal.title")}</div>
          }
          fullScreen={!isDesktopAndUp}
          showCloseButton={true}
          bottomFixedContent={
            <button
              className={cn(
                "footer-button",
                isDesktopAndUp ? [] : ["full-width"]
              )}
              onClick={props.onClose}
            >
              {t("core-hotels.lodgingCancellationPolicyModal.cancelButtonText")}
            </button>
          }
        >
          <div className={cn("container")}>
            <div className={cn("policy-list")}>{props.children}</div>
            <div className={cn("footer")}>
              <span>
                <Icon iconName={IconNameEnum.clock} />
              </span>
              <span>
                {t("core-hotels.lodgingCancellationPolicyModal.footer")}
              </span>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};
